import { useLocation, useNavigate } from "react-router-dom";
import { LoadingSpinner } from 'components/common';
import { Card, IconButton } from 'components/common';
import { FaArrowLeft, FaDownload, FaList, FaSpinner } from "react-icons/fa";
import GDS from "./print/GDS";
import "assets/scss/print-form.scss";
import BDS1 from "./print/BDS1";
import BDS2 from "./print/BDS2";
import BDS3 from "./print/BDS3";
import { CRM_PIF_ISO } from "app_config";
import { useState } from "react";
import { toast } from "react-toastify";
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import {downloadPIF} from "redux/crm/project/pifSlice";
import { usePifFromRoute } from "./usePifFromRoute";

const HeaderPrint = ({pif, download}) => {
  const navigate = useNavigate();
  const {project} = pif;

  const handleBackToProject = () => {
    navigate(`/crm/projects/${project?.id}`)
  }

  const handleDownloadPDF = () => {
    download()
  }

  return (
    <>
      <Card className="tw-mb-3" padding="none">
        <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3">
          <IconButton
            onClick={() => navigate(-1)}
            variant="ghost"
            size="sm"
            icon={<FaArrowLeft size={12} />}
          />
          <div className="tw-flex">
            <IconButton
              variant="ghost"
              size="sm"
              icon={<FaDownload size={12} />}
              iconAlign="middle"
              className="tw-hidden sm:tw-inline-flex tw-mr-1"
              onClick={handleDownloadPDF}
              title="Download"
            >
            </IconButton>

            <IconButton
              variant="ghost"
              size="sm"
              icon={<FaList size={12} />}
              iconAlign="middle"
              className="tw-hidden sm:tw-inline-flex tw-mr-1"
              onClick={handleBackToProject}
            >
              <span className="tw-hidden xl:tw-inline-block tw-ml-1">
                Back to Project
              </span>
            </IconButton>
          </div>
        </div>
      </Card>
    </>
  );
}

HeaderPrint.propTypes = {
  pif: PropTypes.object.isRequired,
  download: PropTypes.func.isRequired
}

const PageBreak = ({ children }) => {
  return (
    <div
      style={{
        pageBreakBefore: "always",
        pageBreakAfter: "always",
        breakBefore: "always", // for newer browsers
        breakAfter: "always",  // for newer browsers
      }}
    >
      {children}
    </div>
  );
};

PageBreak.propTypes = {
  children: PropTypes.object.isRequired
}

const PIFPrint = () => {
  const location = useLocation();
  // The snapshot the detail page passed along is only a placeholder so the page
  // paints immediately; `usePifFromRoute` replaces it with the stored record.
  // Reading it as the source of truth is what made the preview show pre-edit
  // content after a back/forward, and crash when the URL was opened directly.
  const { pif, loading } = usePifFromRoute(location.state?.pif ?? null);

  const [showExporting, setExporting] = useState(false);
  const dispatch = useDispatch();

  // const handleDownload = () => {
  //   setExporting(true)
  //   generatePDF(getTargetElement, options)
  //     .then(() => {
  //       setExporting(false);
  //     })
  //     .catch(error => {
  //       console.error('Error generating PDF:', error);
  //       toast.error('Error generating PDF:', error)
  //       setExporting(false)
  //     })
  // }

  const project = pif?.project;
  const building = pif?.building;
  const adaptation = pif?.adaptation;
  const areas = pif?.areas || [];

  const handleDownload = async () => {
    try {
      setExporting(true)
      await dispatch(downloadPIF({
        projectId: project.id,
        buildingId: building.id,
        adaptationId: adaptation.id,
        pifId: pif.id
      })).unwrap();
    }
    catch(error) {
      toast.error(error.message);
    }
    finally {
      setExporting(false)
    }
  }

  // Only when there is no snapshot to paint while the request is in flight —
  // opening the print URL directly, or reloading it.
  if (!pif) {
    return loading
      ? <LoadingSpinner message="Loading PIF..." />
      : <LoadingSpinner message="This PIF could not be loaded." />;
  }

  return (
    <Card className="tw-m-2" padding="none">
      <HeaderPrint pif={pif} download={handleDownload} />

      {showExporting && (
        <div className="tw-flex tw-items-center tw-justify-center">
          <FaSpinner className="tw-animate-spin tw-mr-2" role="status" /> Downloading...
        </div>
      )}

      <div id="pif-form" className="tw-m-4 print-form responsive-table tw-text-slate-900">
        <GDS pif={pif} />
        Execution stage
        {areas && areas.map(item => (
          <div key={item.id}>
            <PageBreak>
              <BDS1 pif={pif} area={item} />
            </PageBreak>
            <PageBreak>
              <BDS2 pif={pif} area={item} />
            </PageBreak>
            <PageBreak>
              <BDS3 pif={pif} area={item} />
            </PageBreak>
          </div>
        ))}

        <div className="tw-my-2 tw-text-sm">{CRM_PIF_ISO}</div>
      </div>
    </Card>
  )
}

export default PIFPrint;
